import { get } from 'lodash';
import i18next from 'i18next';

import {
  PATHS_AVAILABLE_IN_ALL_WORKSPACES,
  HELP_CENTER_COMPONENT_NAME,
  REFERRAL_COMPONENT_NAME,
} from '@commons/constants/centralConstants';

export const getRoleRightsColumns = (hasCentralKitchens) => [
  {
    id: 'right',
    name: i18next.t('GENERAL.RIGHT'),
    propertyKey: 'name',
    filterType: 'text',
  },
  {
    id: 'module',
    name: i18next.t('GENERAL.MODULE'),
    propertyKey: 'module',
    filterType: 'text',
  },
  {
    id: 'page',
    name: i18next.t('GENERAL.PAGE'),
    propertyKey: 'page',
    filterType: 'text',
  },
  {
    id: 'path',
    name: i18next.t('GENERAL.PATH'),
    propertyKey: 'path',
    displayBigger: true,
  },
  {
    id: 'isCentral',
    name: i18next.t('GENERAL.WORKSPACE'),
    propertyKey: 'isCentral',
    baseName: 'isCentral',
    hidden: !hasCentralKitchens,
    excludeFromSearch: true,
    render: (isCentral, action) => {
      const featurePathMainModule = get(action.path.split('/'), '[1]', '');

      if (
        PATHS_AVAILABLE_IN_ALL_WORKSPACES.includes(featurePathMainModule) ||
        action.page === HELP_CENTER_COMPONENT_NAME ||
        action.page === REFERRAL_COMPONENT_NAME
      ) {
        return i18next.t('GENERAL.COMMON');
      }

      return isCentral ? i18next.t('GENERAL.CENTRAL') : i18next.t('GENERAL.SALE_POINT');
    },
  },
];

export default { getRoleRightsColumns };
